import React, { useState } from "react";
import ReactDOM from "react-dom/client";
import Modal from "components/shared/ScopedModal";

const ShippingEstimate = (props) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [estimate, setEstimate] = useState(props.shipping_estimates[0]);

  const openModal = () => {
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };

  const onChange = (e) => {
    const val = parseInt(e.target.value);
    setEstimate(props.shipping_estimates.find((e) => e.id === val));
  };

  return (
    <>
      <div className="flex flex-col md:flex-row md:items-baseline md:justify-between">
        <div>
          Ships in {estimate.prod_days} working days —{" "}
          <button
            type="button"
            onClick={openModal}
            className="underline hover:no-underline"
          >
            Shipping info
          </button>
        </div>
        <div>Handcrafted in {window.App.currentCountryName}</div>
      </div>
      <Modal
        open={modalIsOpen}
        onClose={closeModal}
        classNames={{
          overlay: "custom-overlay",
          modal: "custom-modal modal-small !bg-pale",
        }}
      >
        <div className="modal-scroll">
          <div className="">
            <div className="px-3 mb-4 mt-3">
              <div className="mb-3">
                <img
                  src={props.shipping_icon}
                  className="-mt-6 w-28 mx-auto"
                  alt="Shipping icon"
                />
                <h2 className="mb-2 mt-0">Delivered right to your door</h2>
                <div className="mt-2 ">
                  <i className="fa-solid fa-shield-check mr-1"></i>
                  Tracked and fully insured shipping
                </div>
              </div>
            </div>
            <div className="pt-3 text-sm">
              {props.shipping_estimates.length > 1 && (
                <div className="form-group select optional mb-1 px-3">
                  <label className="mb-2 block">Ship this order to...</label>
                  <select
                    value={estimate.id}
                    onChange={onChange}
                    className="form-control select custom-select"
                  >
                    {props.shipping_estimates.map((est, i) => (
                      <option key={i} value={est.id}>
                        {est.title}
                      </option>
                    ))}
                  </select>
                </div>
              )}
              <div className="px-3 py-1">
                Place order
                <span className="float-right">Today</span>
              </div>
              <div className="px-3 py-1">
                {estimate.prod_days > 1
                  ? "Production Time"
                  : "Ready for dispatch"}
                <span className="float-right">
                  {estimate.prod_days > 1
                    ? `${estimate.prod_days} working days`
                    : "by next business day"}
                </span>
              </div>
              <div className="px-3 py-1">
                Delivery time
                <span className="float-right">{estimate.days}</span>
              </div>
              <div className="px-3 py-1">
                <strong>On your wall in about...</strong>
                <strong className="float-right">
                  {estimate.total_days} working days
                </strong>
              </div>
            </div>
          </div>
          <div className="card px-3 pt-6 bg-white">
            <div className="grid grid-cols-3">
              <div className="col-span-2">
                <span className="mini-heading text-xxs">
                  Estimated delivery on
                </span>
                <div className="mb-4 mt-1 text-2xl">{estimate.date}</div>
              </div>
              <div className="col-span-1 text-right">
                <span className="mini-heading text-xxs">Cost from</span>
                <div className="mb-4 mt-1">
                  {estimate.cost > 0 && estimate.united_mm !== null ? (
                    <div className="mb-0 text-2xl">
                      <span className="font-bold text-xs font-sans relative -top-2 mr-0.5">
                        {window.App.currencySymbol}
                      </span>
                      {estimate.cost}
                    </div>
                  ) : (
                    <div className="mb-0 text-2xl">TBC</div>
                  )}
                </div>
              </div>
            </div>
            <div className="text-sm mb-3 border-t border-black pt-5 mt-4">
              {estimate.united_mm == null && (
                <div className="font-bold">
                  Cost is determined by the final size of the frame.
                </div>
              )}
              Orders with multiple items may increase the cost shown. Proceed to
              checkout to see final pricing.
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ShippingEstimate;
